var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos2Mobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 19.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Video mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.93,22.41a4.89,4.89,0,0,0-1.11-2.78A3.94,3.94,0,0,0,35,18.44s-3.9-.28-9.79-.28-9.8.28-9.8.28a3.92,3.92,0,0,0-2.81,1.19,4.89,4.89,0,0,0-1.11,2.78,36.89,36.89,0,0,0-.28,4.53v2.12a36.89,36.89,0,0,0,.28,4.53,4.94,4.94,0,0,0,1.11,2.78,4.73,4.73,0,0,0,3.09,1.19s2.24.22,9.52.28c5.89,0,9.79-.29,9.79-.29a4.05,4.05,0,0,0,2.82-1.18,4.94,4.94,0,0,0,1.11-2.78,39.35,39.35,0,0,0,.28-4.53V26.94A39.35,39.35,0,0,0,38.93,22.41ZM22.32,31.63V23.77l7.56,3.95Z",
    transform: "translate(-11.21 -18.16)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos2Mobil);
export default __webpack_public_path__ + "static/media/videos2-mobil.3e53536ad81af336bd3e232754f7f148.svg";
export { ForwardRef as ReactComponent };